import Header from "@components/Header.jsx";
import {Card, Statistic} from "antd";
import React from "react";

import {useCurrentUserFromFirestore} from "@/utils/useCurrentUserFromFirestore.js";

const InventoryPage = () => {
    const {firestoreUser} = useCurrentUserFromFirestore();

    return (
        <div className={`inventory-page`}>
            <div className={`wrapper`}>
                <div className={`page page-app`}>
                <Header title='Inventory' />
                    <div className={`page-content`}>

                            <Card style={{ flex: 1, marginBottom: '10px' }}>
                                <Statistic title="Available"  value={firestoreUser?.available}  valueStyle={{ color: 'green' }} />
                            </Card>
                            <Card style={{ flex: 1, marginBottom: '10px' }}>
                                <Statistic title="Cancel" value={firestoreUser?.cancel} valueStyle={{ color: 'blue' }} />
                            </Card>
                            <Card style={{ flex: 1, marginBottom: '10px' }}>
                                <Statistic title="Refound" value={firestoreUser?.refound } valueStyle={{ color: 'black' }} />
                            </Card>
                            <Card style={{ flex: 1, marginBottom: '10px' }}>
                                <Statistic title="Total" value={firestoreUser?.total } valueStyle={{ color: 'black' }} />
                            </Card>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default InventoryPage;